var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadStickerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19.37,
    viewBox: "0 0 24 19.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m24,4.3v6.07l-1.67,1.67-5.66,5.67-1.67,1.67h-6.07c-1.04,0-2-.37-2.74-.99l1.19-1.19c.44.32.97.51,1.56.51h5.38v-4.55c0-1.91,1.56-3.47,3.47-3.47h4.55v-5.38c0-1.46-1.18-2.64-2.64-2.64h-10.77c-1.45,0-2.64,1.18-2.64,2.64v.75h-1.67v-.75C4.62,1.93,6.56,0,8.93,0h10.77c2.37,0,4.3,1.93,4.3,4.3Zm-14.31,6.46l-2.06,2.05-1.3,1.29v-7.87h-1.74v7.88l-3.36-3.36-1.23,1.24,5.2,5.22.25.25,1.16-1.16,4.32-4.32-1.23-1.23Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadStickerIcon);
export default __webpack_public_path__ + "static/media/download-sticker-icon.a4aefe95d187b8e519f8d43541b61933.svg";
export { ForwardRef as ReactComponent };